// extracted by mini-css-extract-plugin
export default {"mobileSearchBar":"MobileSearchBar_mobileSearchBar__1qNcA"};